"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@xyflow/react");
var fields_from_schema_1 = require("../../../helpers/fields_from_schema");
var react_3 = require("react");
var condition_node_1 = __importDefault(require("../condition_node"));
var challenge_1 = require("../../../../../../../reducers/slices/challenge/challenge");
var react_redux_1 = require("react-redux");
var challengeEditorContext_1 = require("../../../../../../../contexts/challengeEditorContext");
var UniqueConditionNode = function (props) {
    var isReadOnly = (0, challengeEditorContext_1.useChallengeReadOnly)();
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_3.useState)(null), schema = _a[0], setSchema = _a[1];
    var setConfigData = function (config) {
        dispatch((0, challenge_1.setNode)(__assign(__assign({}, props), { data: __assign(__assign({}, data), { config: config }) })));
    };
    var flow = null;
    try {
        flow = (0, react_2.useReactFlow)();
    }
    catch (error) {
        if (props.id) {
            console.error(error);
        }
    }
    (0, react_3.useEffect)(function () {
        if (flow) {
            var nodes = flow.getNodes();
            var edges = flow.getEdges();
            setSchema((0, fields_from_schema_1.combineSchemas)(props, nodes, edges));
        }
    }, [flow, props]);
    var schemaOptions = (0, react_3.useMemo)(function () {
        var flatSchema = (0, fields_from_schema_1.getFlattenedSchema)(schema, "$.");
        return Object.keys(flatSchema).map(function (key) { return ({ key: key }); });
    }, [schema]);
    var configurationComponent = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-2", children: (0, jsx_runtime_1.jsxs)(react_1.ComboBox, { isDisabled: isReadOnly, selectedKey: data.config.field, onSelectionChange: function (key) {
                    setConfigData(__assign(__assign({}, data.config), { field: key }));
                }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Field" }), (0, jsx_runtime_1.jsxs)(react_1.ComboBox.InputGroup, { children: [(0, jsx_runtime_1.jsx)(react_1.Input, {}), (0, jsx_runtime_1.jsx)(react_1.ComboBox.Trigger, {})] }), (0, jsx_runtime_1.jsx)(react_1.ComboBox.Popover, { children: (0, jsx_runtime_1.jsx)(react_1.ListBox, { items: schemaOptions, children: function (option) { return ((0, jsx_runtime_1.jsxs)(react_1.ListBox.Item, { id: option.key, textValue: option.key, children: [option.key, (0, jsx_runtime_1.jsx)(react_1.ListBox.ItemIndicator, {})] })); } }) })] }) }));
    };
    return (0, jsx_runtime_1.jsx)(condition_node_1.default, __assign({ data: data }, props, { configurationComponent: configurationComponent }));
};
exports.default = (0, react_3.memo)(UniqueConditionNode);
